import { Loader2, Plus } from "lucide-react";
import type { FC } from "react";

import { SidebarMenuAction } from "@/components/ui/sidebar";

import { NewRequestMenu } from "./NewRequestMenu";
import { useNewRequest } from "./useNewRequest";

/**
 * A "+" on the Requests row of the client nav, for New Request while the
 * stages are folded away (shown on hover and focus).
 */
export const RequestsQuickAction: FC = () => {
  const newRequest = useNewRequest();
  return (
    <NewRequestMenu
      align="start"
      onNewRequest={(action) => void newRequest.start(action)}
      trigger={
        <SidebarMenuAction
          showOnHover
          aria-label="New Request"
          title="New Request"
          disabled={newRequest.busy}
          data-testid="requests-quick-new"
          className="right-1 w-6 text-fg-3 hover:bg-fill-2 hover:text-fg"
        >
          {newRequest.busy ? <Loader2 className="animate-spin" /> : <Plus />}
        </SidebarMenuAction>
      }
    />
  );
};
